'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { FactsSectionModel } from '../../types'
import FactsSectionCard from './FactsSectionCard'

type Props = { props: FactsSectionModel }

const FactsSection = ({ props }: Props) => {
  const { testId, text, cards } = props
  const translate = useTranslate()

  const renderCards = () =>
    cards.map((card, index) => <FactsSectionCard key={index} props={card} />)

  return (
    <section className="secondhand-taxes__facts-cards-section" data-testid={testId}>
      <h2 className="secondhand-taxes__facts-card-section-title">{translate(text.title)}</h2>
      <div className="secondhand-taxes__facts-cards-container">{renderCards()}</div>
    </section>
  )
}

export default FactsSection
